export enum EClearbitLogoStatus {
  DISABLED = "DISABLED"
}

export interface ClearbitAutocompleteDTO {
  domain: string;
  logo: string;
  name: string;
};
